export { LoaderWrapperDS } from './loader-wrapper-ds'
export type { LoaderWrapperDSProps } from './loader-wrapper-ds.types'
